export default {
    rei_82: 'Unsafe water, sanitation, and handwashing',
    rei_83: 'Unsafe water source',
    rei_84: 'Unsafe sanitation',
    rei_85: 'Air pollution',
    rei_86: 'Ambient particulate matter pollution',
    rei_87: 'Household air pollution from solid fuels',
    rei_88: 'Ambient ozone pollution',
    rei_89: 'Other environmental risks',
    rei_90: 'Residential radon',
    rei_91: 'Lead exposure',
    rei_92: 'Child and maternal malnutrition',
    rei_93: 'Suboptimal breastfeeding',
    rei_94: 'Child underweight',
    rei_95: 'Iron deficiency',
    rei_96: 'Vitamin A deficiency',
    rei_97: 'Zinc deficiency',
    rei_98: 'Tobacco',
    rei_99: 'Smoking',
    rei_100: 'Secondhand smoke',

    rei_102: 'Alcohol use',
    rei_103: 'Drug use',
    rei_104: 'Metabolic risks',
    rei_105: 'High fasting plasma glucose',

    rei_107: 'High systolic blood pressure',
    rei_108: 'High body-mass index',
    rei_109: 'Low bone mineral density',
    rei_110: 'Dietary risks',
    rei_111: 'Diet low in fruits',
    rei_112: 'Diet low in vegetables',
    rei_113: 'Diet low in whole grains',
    rei_114: 'Diet low in nuts and seeds',
    rei_115: 'Diet low in milk',
    rei_116: 'Diet high in red meat',
    rei_117: 'Diet high in processed meat',
    rei_118: 'Diet high in sugar-sweetened beverages',
    rei_119: 'Diet low in fiber',

    rei_121: 'Diet low in seafood omega-3 fatty acids',
    rei_122: 'Diet low in polyunsaturated fatty acids',
    rei_123: 'Diet high in trans fatty acids',
    rei_124: 'Diet high in sodium',
    rei_125: 'Low physical activity',
    rei_126: 'Occupational risks',
    rei_127: 'Occupational carcinogens',
    rei_128: 'Occupational asthmagens',
    rei_129: 'Occupational particulate matter, gases, and fumes',
    rei_130: 'Occupational noise',
    rei_131: 'Occupational injuries',
    rei_132: 'Occupational ergonomic factors',
    rei_333: 'Diet low in legumes',
    rei_134: 'Childhood sexual abuse',
    rei_135: 'Intimate partner violence',
    rei_136: 'Non-exclusive breastfeeding',
    rei_137: 'Discontinued breastfeeding',
    rei_138: 'Injected drug use',
    rei_140: 'Drug dependence',

    rei_147: 'Diet low in calcium',

    rei_150: 'Occupational exposure to asbestos',
    rei_151: 'Occupational exposure to arsenic',
    rei_152: 'Occupational exposure to benzene',
    rei_153: 'Occupational exposure to beryllium',
    rei_154: 'Occupational exposure to cadmium',
    rei_155: 'Occupational exposure to chromium',
    rei_156: 'Occupational exposure to diesel engine exhaust',
    rei_158: 'Occupational exposure to formaldehyde',
    rei_159: 'Occupational exposure to nickel',
    rei_160: 'Occupational exposure to polycyclic aromatic hydrocarbons',
    rei_161: 'Occupational exposure to silica',
    rei_162: 'Occupational exposure to sulfuric acid',
    rei_167: 'Intimate partner violence (exposure approach)',
    rei_168: 'Intimate partner violence (direct PAF approach)',

    rei_169: 'All risk factors',
    rei_170: 'Unsafe sex',
    rei_171: 'Etiologies',
    rei_172: 'Diarrheal disease etiologies',
    rei_173: 'Cholera',
    rei_174: 'Non-typhoidal Salmonella',
    rei_175: 'Shigella',
    rei_176: 'Enteropathogenic E coli',
    rei_177: 'Enterotoxigenic E coli',
    rei_178: 'Campylobacter',
    rei_179: 'Entamoeba',
    rei_180: 'Cryptosporidium',
    rei_181: 'Rotavirus',
    rei_182: 'Aeromonas',
    rei_183: 'Clostridium difficile',
    rei_184: 'Norovirus',
    rei_185: 'Adenovirus',
    rei_186: 'Lower respiratory infection etiologies',
    rei_187: 'Influenza',
    rei_188: 'Pneumococcal pneumonia',
    rei_189: 'H influenzae type B',
    rei_190: 'Respiratory syncytial virus',
    rei_191: 'Impairments',
    rei_192: 'Anemia',
    rei_193: 'Epilepsy',
    rei_194: 'Guillain-Barré syndrome',
    rei_195: 'Hearing loss',
    rei_196: 'Heart failure',
    rei_197: 'Developmental intellectual disability',
    rei_198: 'Infertility',
    rei_199: 'Pelvic inflammatory disease',
    rei_200: 'Blindness and vision impairment',

    rei_201: 'Intimate partner violence (HIV PAF approach)',
    rei_202: 'Environmental/occupational risks',
    rei_203: 'Behavioral risks',

    rei_205: 'Mild anemia',
    rei_206: 'Moderate anemia',
    rei_207: 'Severe anemia',
    rei_208: 'Treated epilepsy',
    rei_209: 'Moderate epilepsy',
    rei_210: 'Severe epilepsy',
    rei_211: 'Mild hearing loss',
    rei_212: 'Moderate hearing loss',
    rei_213: 'Moderately severe hearing loss',
    rei_214: 'Severe hearing loss',
    rei_215: 'Profound hearing loss',
    rei_216: 'Complete hearing loss',
    rei_217: 'Mild heart failure',
    rei_218: 'Moderate heart failure',
    rei_219: 'Severe heart failure',
    rei_220: 'Primary infertility',
    rei_221: 'Secondary infertility',
    rei_222: 'Mild intellectual disability',
    rei_223: 'Moderate intellectual disability',
    rei_224: 'Severe intellectual disability',
    rei_225: 'Profound intellectual disability',
    rei_226: 'Moderate pelvic inflammatory disease',
    rei_227: 'Severe pelvic inflammatory disease',
    rei_228: 'Mild vision loss',
    rei_229: 'Moderate vision loss',
    rei_230: 'Severe vision loss',
    rei_231: 'Blindness',
    rei_232: 'Monocular vision loss',
    rei_233: 'Presbyopia',

    rei_236: 'Borderline intellectual disability',
    rei_237: 'Occupational exposure to trichloroethylene',
    rei_238: 'No access to handwashing facility',
    rei_239: 'Child growth failure',
    rei_240: 'Child wasting',
    rei_241: 'Child stunting',
    rei_242: 'Lead exposure in blood',
    rei_243: 'Lead exposure in bone',
    rei_244: 'Childhood sexual abuse against females',
    rei_245: 'Childhood sexual abuse against males',

    rei_309: 'Total Hypertension',
    rei_331: 'Non-optimal temperature',
    rei_332: 'Chewing tobacco',
    rei_334: 'Short gestation for birth weight',
    rei_335: 'Low birth weight for gestation',

    rei_337: 'High temperature',
    rei_338: 'Low temperature',
    rei_339: 'Low birth weight and short gestation',

    rei_341: 'Impaired kidney function',

    rei_363: 'Bullying victimization',
    rei_367: 'High LDL cholesterol',
    rei_368: 'Fistula',

    rei_370: 'High body-mass index in adults',
    rei_371: 'High body-mass index in children',

    rei_379: 'Treated heart failure',
    rei_380: 'Particulate matter pollution',
    rei_381: 'Childhood maltreatment',

    rei_386: 'Meningococcal meningitis',

    rei_393: 'Group B streptococcus',

    rei_404: 'Nitrogen dioxide pollution',

    rei_412: 'Astrovirus',
    rei_413: 'Sapovirus',
    rei_414: 'Acinetobacter baumannii',
    rei_415: 'Chlamydia spp',
    rei_416: 'Enterobacter spp',
    rei_417: 'Escherichia coli',
    rei_418: 'Fungus',
    rei_419: 'Haemophilus influenzae',
    rei_420: 'Klebsiella pneumoniae',
    rei_421: 'Legionella spp',
    rei_422: 'Listeria monocytogenes',
    rei_423: 'Mycoplasma',
    rei_424: 'Other bacterial pathogen',
    rei_425: 'Other viral etiologies of LRI',
    rei_426: 'Polymicrobial',
    rei_427: 'Pseudomonas aeruginosa',
    rei_428: 'Staphylococcus aureus',
    rei_429: 'Viral etiologies of meningitis',
    rei_430: 'Streptococcus pneumoniae',
    rei_431: 'Neisseria meningitidis',
    rei_432: 'Moderate and Severe Anemia',

    rei_587: 'Diabetes - Total',

    rei_620: 'Aspergillus spp.',
    rei_621: 'Other Acinetobacter species',
    rei_622: 'Citrobacter spp',
    rei_623: 'Other fungi',
    rei_624: 'Other gram-negative bacteria',
    rei_625: 'Other Klebsiella species',
    rei_626: 'Morganella spp',
    rei_627: 'Other Mycobacterium species (non-TB, non-Leprosy)',
    rei_628: 'Proteus spp',
    rei_629: 'Serratia spp',
    rei_630: 'Group A Streptococcus',
    rei_631: 'Candida spp',
    rei_632: 'Coagulase negative staphylococci',
    rei_633: 'Non-polio enteroviruses',
    rei_634: 'Other streptococcus species',

    rei_1021: 'Any Drinking',
    rei_1028: 'Binge Drinking',
    rei_1251: 'Any Physical Activity',
    rei_1252: 'Recommended Physical Activity',
    rei_3051: 'Overweight (25+ kg/m^2)',
    rei_3061: 'Obesity (30+ kg/m^2)',
    rei_3099: 'Uncontrolled Hypertension',
    rei_3700: 'Mean BMI (kg/m^2)',
    rei_5871: 'Diabetes - Diagnosed',
    rei_5872: 'Diabetes - Undiagnosed',
    rei_9908: 'Daily Smoking',
    rei_10208: 'Binge Drinking Among Drinkers',
    rei_10209: 'Heavy Drinking Among Drinkers',
    rei_30901: 'Hypertension Awareness',
    rei_30902: 'Hypertension Treatment',
    rei_30903: 'Hypertension Control',
    rei_50014: 'Underweight: Adult BMI <18.5 kg/m^2',
    rei_50015: 'Normal weight: Adult BMI 18.5-24.9 kg/m^2',
    rei_50016: 'Overweight (excluding obesity): Adult BMI 25.0-29.9 kg/m^2',
    rei_50017: 'Obesity Class I: Adult BMI 30.0-34.9 kg/m^2',
    rei_50018: 'Obesity Class II: Adult BMI 35.0-39.9 kg/m^2',
    rei_50019: 'Obesity Class III: Adult BMI 40+ kg/m^2',
    rei_50020: 'Obesity: Adult BMI 30+ kg/m^2',
    rei_50021: 'Overweight (including obesity): Adult BMI 25+ kg/m^2',
    rei_58701: 'Diabetes - Awareness',
    rei_58702: 'Diabetes - Control',
};
